// Mint-Cost-Phone · "Nhập phí hiện trường": dữ liệu mẫu của board (ITEMS) + nghĩa chip (COST-LOGIC). Chỉ đọc.

export type PhoneStatus = 'Created' | 'Approved' | 'Nháp' | 'Need Revise';
export interface PhoneItem { title: string; job: string; chips: string[]; amt: string; status: PhoneStatus; returned: boolean; why: string }

const mk = (title: string, job: string, chips: string, amt: string, status: PhoneStatus, returned: boolean, why: string): PhoneItem => ({
  title, job, chips: chips.split(' · '), amt, status, returned, why,
});

export const PHONE_ITEMS: readonly PhoneItem[] = [
  mk('Phụ thu phí nâng 40 hàng lạnh · ODN2670968', 'SE260635440', 'ONN · BIL · BNK · INV', '2,4 tr', 'Created', false, 'Chờ kế toán ghép HĐ 1/C26TCL/1414392'),
  mk('Phí hạ sớm tại cảng · ODN2670965', 'SE260635820', 'ELF · BIL · EMP · RCP', '1,2 tr', 'Created', false, 'Chờ cấp 1 [OPS-MGR] PHONGNT'),
  mk('Phí nâng hạ · ODN2670959', 'SL260635660', 'ONN · BIL · EMP · RCP', '0,6 tr', 'Approved', false, 'Đã duyệt · chờ vào đợt chi'),
  mk('Phí cầu đường', 'SE260608050', 'XLH · OBH · EMP · RCP', '0,8 tr', 'Nháp', false, 'Chưa gửi — gửi trước 23:59 hôm nay'),
  mk('Biên nhận nâng hạ · ODN2670957', 'SE260633750', 'OFF · BIL · EMP · RCP', '1,4 tr', 'Need Revise', true, 'Ảnh mờ, không đọc được số tiền'),
  mk('Lệ phí hải quan · ODN2670951', 'SL260623140', 'CUF · OBH · BNK · RCP', '0,3 tr', 'Need Revise', true, 'Sai job — khoản này thuộc SL260623120'),
];

const NAT: Record<string, string> = { BIL: 'Tính khách · có markup', OBH: 'Chi hộ khách · khoá markup', ABS: 'HANA chịu', EXC: 'Ngoại lệ' };
const PAY: Record<string, string> = { BNK: 'Chuyển khoản', EMP: 'Cán bộ ứng trước' };
const DOC: Record<string, string> = { INV: 'Hoá đơn', RCP: 'Biên nhận', PND: 'Phiếu nợ', NDC: 'Không chứng từ' };

/** Nghĩa tiếng Việt của chip (rê chuột / đọc màn hình). */
export function chipTip(k: string): string {
  if (NAT[k]) return `Bản chất ${k} · ${NAT[k]}`;
  if (PAY[k]) return `Người trả ${k} · ${PAY[k]}`;
  if (DOC[k]) return `Chứng từ ${k} · ${DOC[k]}`;
  return `Mã phí ${k}`;
}
export const chipKind = (k: string, i: number): 'nat' | 'pay' | 'doc' | 'code' => (NAT[k] ? 'nat' : PAY[k] ? 'pay' : DOC[k] ? 'doc' : i === 0 ? 'code' : 'code');

export const phoneCounts = () => ({
  today: PHONE_ITEMS.filter((x) => !x.returned).length,
  ret: PHONE_ITEMS.filter((x) => x.returned).length,
});
